import { z } from "zod";
import { MedicationPredictionResponse } from "../types/medication.types";

export default async function fetchMedicationPredictionsFromClinicalTables(params: {
  term: string;
  offset: number;
  limit: number;
}) {
  const baseUrl = "https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search";
  const searchParams = new URLSearchParams({
    ef: "STRENGTHS_AND_FORMS",
    count: params.limit.toString(),
    offset: params.offset.toString(),
    terms: params.term,
  });
  const url = `${baseUrl}?${searchParams.toString()}`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error("Failed to fetch medication suggestions");
  }

  const data = zRawTuple.parse(await response.json());

  return mapRawTuple(data);
}

function mapRawTuple(data: RawTuple): MedicationPredictionResponse {
  const [totalResultsCount, names, { STRENGTHS_AND_FORMS }] = data;

  return {
    totalResultsCount,
    medications: names.map((name, index) => ({
      name: name.trim(),
      doses: STRENGTHS_AND_FORMS[index].map((s) => s.trim()),
    })),
  };
}

const zRawTuple = z.tuple([
  z.number(),
  z.array(z.string()),
  z.object({
    STRENGTHS_AND_FORMS: z.array(z.array(z.string())).optional().default([]),
  }),
  z.array(z.array(z.string())),
]);
type RawTuple = z.infer<typeof zRawTuple>;
